export const environment = {
  envName: "istra-dev",
  production: false,
  url: '',
  urlSuffix: "",
  paymentUrl: "https://pgw.ulaznice.dev/pgw-service",
  apiUrl: "https://api.test.ulaznice.hr/paganini",
  appId: "1",
  redirectUrl: "https://www.test.ulaznice.hr/nk-istra-intra",
  connId: "92",
  recaptchaSiteKey: "6LdghEQrAAAAAGznLjG5pIWKV2twdJ3wZ9HOmsD-",
  webSocketUrl: "wss://apps.test.ulaznice.hr/ws/",
  page: "istra",
  pageFolder: "sport",
  pageTitle: "NK Istra 1961",
  configId: "6",
  googleClientId: "785189596986-n1q65ceijpkm01kuo4lef08qrtfb5tog.apps.googleusercontent.com",
  facebookAppId: "451047933216100",
  officialWebsiteUrl: "https://nkistra.com/",
};
